import React, { useEffect, useState } from 'react';
import Localize from 'react-intl-universal';

import { isEmpty } from 'lodash-es';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import BillingInformation from './BillingInformation';
import OrderSummary from './OrderSummary';

const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  '& .MuiAccordionSummary-content.Mui-expanded': {
    marginBottom: 0
  }
}));

const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  '& .MuiAccordionDetails-root': {
    paddingTop: 0
  }
}));

const Billing = ({ event = {}, fetchBilling, bookingData = {}, minHeight = '' }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      if (isEmpty(bookingData)) {
        setIsLoading(true);
        await fetchBilling();
        setIsLoading(false);
      }
    };

    fetch();
  }, []);

  return (
    <Container
      sx={{ minHeight: minHeight, pl: { xs: 0, sm: 'inherit' }, pr: { xs: 0, sm: 'inherit' } }}
    >
      <Accordion defaultExpanded sx={{ mt: 3 }}>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography component='span' sx={{ fontSize: '1rem', fontWeight: '600' }}>
            {Localize.get('Booking.orderSummary')}
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          {isLoading && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '20vh'
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {!isLoading && <OrderSummary bookingData={bookingData} eventName={event?.name} />}
        </StyledAccordionDetails>
      </Accordion>
      <Accordion>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography component='span' sx={{ fontSize: '1rem', fontWeight: '600' }}>
            {Localize.get('EventDetails.billingInformation')}
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <BillingInformation billingData={bookingData?.billingData || {}} event={event} />
        </StyledAccordionDetails>
      </Accordion>
    </Container>
  );
};

export default Billing;
